export const JuryRoles = {  
    Evaluador: { id: "2122D07A-B54C-479C-A26A-4197DB3CEC60", nombre: "Evaluador" },
    Dictaminador: { id: "A34297B2-8843-4B1C-8CEB-DBE135139926", nombre: "Dictaminador" },   
};